import { MediaOrigin } from './mediaClass';

export enum TemplateType {
  T_NONE = '',
  T_LOWERTHIRD = 'LOWERTHIRD',
  T_TICKER = 'TICKER',
  T_NAMETAG = 'NAMETAG',
  T_LOGO = 'LOGO',
  T_CHAT = 'CHAT'
}

export enum TemplatePosition {
  TOP_LEFT = 'TOPLEFT',
  TOP = 'TOP',
  TOP_RIGHT = 'TOPRIGHT',
  RIGHT = 'RIGHT',
  BOTTOM_RIGHT = 'BOTTOMRIGHT',
  BOTTOM = 'BOTTOM',
  BOTTOM_LEFT = 'BOTTOMLEFT',
  LEFT = 'LEFT',
}

export class Template {
  id: string;
  primaryText: string;
  secondaryText: string;
  name: string;
  model: string;
  source: string;
  number: string;
  type: TemplateType;
  selected: boolean;
  primaryColor: string;
  isNew: boolean;
  isAdding: boolean;
  position: TemplatePosition;
  badgeColor: string;
  initials: string;
  origin: MediaOrigin;

  constructor(id, source, model, name, primary, secondary, type, number, color, isAdding, badgeColor='transparent', initials='', origin = MediaOrigin.USER_ASSET ) {
    this.id = id;
    this.model = model;
    this.source = source;
    this.name = name;
    this.primaryText = primary;
    this.secondaryText = secondary;
    this.number = number;
    this.type = type;
    this.selected = false;
    this.primaryColor = color;
    this.isNew = false;
    this.isAdding = isAdding;
    this.position = TemplatePosition.TOP_RIGHT;
    this.badgeColor = badgeColor;
    this.initials = initials;
    this.origin = origin;
  }
}

export class BrandSettings {
  nametagsActive: boolean;
  primaryColor: string;
  selectedTheme: string;
}

export class TemplateStore {
  brandsettings: BrandSettings;
  selectedLowerThird: any;
  lowerthirds: any[];
  selectedTicker: any;
  tickers: any[];
  templates: any[];
  logos: any[];
  selectedLogos: string[];  // array of string ids

  constructor() {
    this.selectedLowerThird = null;
    this.selectedTicker = null;
    this.templates = [];
    this.lowerthirds = [];
    this.tickers = [];
    this.logos = [];
    this.selectedLogos = [];
    this.brandsettings = {
      nametagsActive: false,
      primaryColor: "",
      selectedTheme: ""
    }
  }

}